module.exports = __webpack_public_path__ + "static/media/bottlings13.e182a986.jpg";